export type DestinationItem = {
  portRuleId: number | null;
  label: string;
};
export type PortOption = {
  portRuleId: number;
  label: string;
  country: string | null;
};
export type CountryRuleChanges = {
  color: string;
  category: string;
  action: string;
  country: string;
  modelRole: string | null;
  destinations: DestinationItem[];
  modalities: string[];
  customCategory?: boolean;
  customAction?: boolean;
};
export type CountryRule = CountryRuleChanges & {
  ruleId: number;
  level: number;
};
export type CountryRuleOptions = {
  colors: {
    color: string;
    level: number;
    categories: string[];
    actions: string[];
  }[];
  ports: PortOption[];
  modalities: {
    value: string;
    label: string;
    icon: string;
  }[];
};
export const countryRuleControl = 'mt-2 min-h-10 w-full border border-slate-300 bg-white px-3 py-2 text-sm text-slate-900 outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 disabled:opacity-50 dark:border-white/20 dark:bg-slate-950 dark:text-white';
